module.exports = __webpack_public_path__ + "img/cameraCircle.2259ca7b.png";